// TenantThemeProvider.tsx
import React, { ReactNode, useMemo } from "react";
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import { getThemeForTenant } from "../configs";
import BaseSiteHomePage from "../pages/base-site/home";
import { useBrandColorVersion } from "./store-branding";

interface TenantThemeProviderProps {
  tenantId: string;
  children: ReactNode;
}

const TenantThemeProvider: React.FC<TenantThemeProviderProps> = ({
  tenantId,
  children,
}) => {
  const brandVersion = useBrandColorVersion();
  const theme = useMemo(() => getThemeForTenant(tenantId), [tenantId, brandVersion]);
  if (!theme) {
    return (
      <MuiThemeProvider theme={theme}>
        <BaseSiteHomePage />
      </MuiThemeProvider>
    );
  }

  return <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>;
};

export default TenantThemeProvider;
